import React, { ReactNode } from 'react';
import * as css from './calendarSearchField.module.scss';
import classNames from 'classnames';

interface CalendarSearchFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  searchCssOutlined: boolean;
  disabled?: boolean;
  icon?: ReactNode;
  inputRef: React.RefObject<HTMLInputElement>;
  button?: ReactNode;
}

// TODO Rewrite this component instead of using it elsewhere.
export const CalendarSearchField: React.FC<
  React.PropsWithChildren<CalendarSearchFieldProps>
> = ({ searchCssOutlined, disabled, icon, inputRef, button, ...props }) => {
  return (
    <div
      className={classNames(
        css.inputWrapper,
        searchCssOutlined && css.outlined,
        disabled && css.disabled,
      )}
    >
      {icon && <div className={css.icon}>{icon}</div>}
      <input ref={inputRef} {...props} />
      {button && <div className={css.button}>{button}</div>}
    </div>
  );
};
